import AddToNotesMenu from './AddToNotesMenu';

export default AddToNotesMenu;
